// LIBRERIE/IMPORTS
import { useTranslation } from "react-i18next";
import { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesDown } from "@fortawesome/free-solid-svg-icons";

// HOOKS
import { useGetAgencyDetails } from "../../../hooks/useGetAgencyDetails";

// CONFIGURAZIONI
import { AGENCY_ID } from "../../../config/appConfig";

// COMPONENTI
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import SlowLoadComponent from "../../Error/SlowLoadComponent";
import PropertySearchField from "../../Home/Search";
import NotFound from "../../Error/NotFound";

interface SubHeaderHomeProps {
    agencyName?: string;
    isSeo: boolean;
    showSearchForm?: boolean;
    loaderFinish: boolean;
}

const SubHeaderHome: React.FC<SubHeaderHomeProps> = ({
    showSearchForm = false /* Default a true se non specificato*/,
    loaderFinish
}) => {

    const LARGE_FILES_URL = import.meta.env.VITE_LARGE_FILES_BASE_URL;

    const { agency, loading, error } = useGetAgencyDetails(AGENCY_ID);
    const { t } = useTranslation();

    // Il video carica sempre al mount, ma quando cambia la props del loader lo fa ripartire da capo
    const videoRef = useRef<HTMLVideoElement>(null);

    const handleVideoStart = () => {
        if (videoRef.current) {
            videoRef.current.play().catch((error) => {
                console.error("Errore durante la riproduzione del video:", error);
            });
        }
    }

    useEffect(() => {
        handleVideoStart();
    },[])

    useEffect(() => {
        if (loaderFinish) {
            videoRef.current?.pause();
            if(videoRef.current) {
                videoRef.current.currentTime = 0;
            }
            handleVideoStart();
        }
    }, [loaderFinish]);

    // console.log(loaderFinish, "loaderFinish in SubHeaderHome.tsx");

    // -----------------------------------------------------------------------------------------------------

    // Transizione per rendere visibile il text wrapper
    const [boxVisible, setBoxVisible] = useState(false);

    useEffect(() => {
        const handleVisible = () => {
            setBoxVisible(true)
        };

        const timer = setTimeout(handleVisible, 3500);
        return () => clearTimeout(timer);
    }, [])

    // Rendering Componente
    if (loading) return <LoadingIndicator />;
    if (error) return <SlowLoadComponent />;
    if (!agency) return <NotFound message={`${t('common.agencyNotFound')}`} />;

    return (
        <section className="banner bg-overlay-black-10">
            {false && (
                <video ref={videoRef} muted loop playsInline onLoadedData={handleVideoStart}>
                    <source src={`${LARGE_FILES_URL}/videoHero.mp4`} type="video/mp4" />
                </video>
            )}

            <img src="/assets/images/inHome/hero.webp" alt={t('homePage.hero.altImage') as string} />
            <div className="container-fluid">
                <div className={`text-wrapper ${boxVisible ? 'visible' : ''} text-center`}>
                    <h2 dangerouslySetInnerHTML={{ __html: t('homePage.hero.title') as string }}></h2>
                    <p>{t('homePage.hero.subTitle')}</p>
                    <div className="row justify-content-center">
                        <div className="col-11">
                            {showSearchForm && <PropertySearchField searchData={{}} />}
                        </div>
                    </div>
                </div>
            </div>
            <div className="scroll-indicator">
                <a href="#search-box" title={t('homePage.hero.scrollDownTitle') as string}>
                    <FontAwesomeIcon icon={faAnglesDown} />
                </a>
            </div>
        </section>
    );
};

export default SubHeaderHome;